<template>
  <div class="social-sharing">
    <div class="flex items-center">
      <div class="mr-2 px-4 py-2">
        <h3 class="text-[14px] font-medium uppercase leading-[17px]">
          Поделиться
        </h3>
      </div>
      <div class="flex items-center">
        <SvgIcon
          name="socials-redisign/copy"
          class="mr-4 size-5 cursor-pointer text-new-card--title-black"
          @click="copyLink"
        ></SvgIcon>
        <span
          v-for="social in socials"
          :key="`social-sharing-item-${social.id}`"
          class="mr-4 cursor-pointer text-new-card--title-black last:mr-0"
          @click="handleShareLink(social.share)"
        >
          <SvgIcon :name="social.icon" class="size-5"></SvgIcon>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute();
const toast = useToast();

const socials = [
  {
    id: 0,
    share: `//vk.com/share.php?url=https://histrf.ru${route.fullPath}`,
    icon: 'socials-redisign/vk',
  },
  {
    id: 1,
    share: `https://t.me/share/url?url=https://histrf.ru${route.fullPath}`,
    icon: 'socials-redisign/tg',
  },
  {
    id: 2,
    share: `https://connect.ok.ru/offer?url=https://histrf.ru${route.fullPath}`,
    icon: 'socials-redisign/ok',
  },
];

const copyLink = () => {
  navigator.clipboard
    .writeText(`https://histrf.ru${route.fullPath}`)
    .then(() => {
      toast.success('Скопировано!');
    })
    .catch(() => {
      toast.error('Ошибка копирования');
    });
};

const handleShareLink = (link) => {
  window.open(link, '_blank');
};
</script>

<style lang="scss"></style>
